export const LAX = {
  label: 'LAX',
  value: 'LAX',
  center: [33.767715, -118.190886],
  timezone: 'America/Los_Angeles',
};

export const SFO = {
  label: 'SFO',
  value: 'SFO',
  timezone: 'America/Los_Angeles',
};

export const NYC = {
  label: 'NYC',
  value: 'NYC',
  timezone: 'America/New_York',
};

export const CHI = {
  label: 'CHI',
  value: 'CHI',
  timezone: 'America/Chicago',
};

export const SEA = {
  label: 'SEA',
  value: 'SEA',
  timezone: 'America/Los_Angeles',
}
const MARKETS = [
  LAX,
  SFO,
  NYC,
  CHI,
  SEA
];

export default MARKETS;
